import { Collection } from 'vue-mc';
import axiosConfig from './config';

export default class extends Collection {

	getRequest(config) {
		axiosConfig(config);
		return super.getRequest(config);
	}
	
	/**
	 * Return true if collection is changing (loading, saving, or deleting)
	 * @returns {boolean}
	 */
	get changing() {
		return (this.loading || this.saving || this.deleting);
	}

}
